var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 30,
    viewBox: "0 0 30 30",
    width: 30,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m17.5403516 10.9943393c0 1.0639683-.177328 2.2166007-.5319842 3.280569-.3546561 1.0639683-.8866402 2.0392726-1.5072884 2.9259129-1.3299604 1.7732805-3.191905 3.1032409-5.2311776 3.7238891-1.0639683.3546561-2.12793662.4433201-3.19190495.4433201-1.06396832 0-2.12793664-.177328-3.10324093-.5319841-1.50728845-.5319842-2.74858483-1.4186245-3.81255315-2.4825928-.26599208-.2659921 0-.7093122.35465611-.5319841.88664027.3546561 1.77328053.5319841 2.6599208.6206482 1.3299604.088664 2.74858483-.2659921 3.90121717-.8866403 2.39392873-1.2412964 3.90121715-3.8125532 3.90121715-6.472474.0886641-2.65992076-1.50728842-5.23117754-3.90121715-6.47247391-1.15263234-.62064819-2.57125677-.9753043-3.90121717-.88664027-.88664027 0-1.77328053.26599208-2.6599208.62064819-.35465611.17732805-.62064819-.26599208-.35465611-.53198416.9753043-1.15263235 2.3052647-1.95060859 3.81255315-2.48259275.97530429-.35465611 2.03927261-.53198416 3.10324093-.53198416 1.06396833 0 2.12793665.17732805 3.19190495.44332013 2.0392726.62064819 3.9012172 1.95060859 5.2311776 3.72388913.7093122.70931221 1.1526323 1.77328053 1.5072884 2.74858482.3546562 1.41862443.5319842 2.51214738.5319842 3.28056898z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    transform: "translate(6.754641 3.680256)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/moon.748f6d060151fa65e2bc9d9f881d23fc.svg";
export { ForwardRef as ReactComponent };